import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { ComisionManualItem } from "../../../reducers/comisionManual";
import {
  formatMoney,
  formatIsoDate,
  formatEnum
} from "../../../helpers/formatters";
import { UncontrolledTooltip } from "reactstrap";

export interface TableProps {
  comisiones: ComisionManualItem[];
  loading: boolean;
  onDelete: (id: number) => void;
  deleting: boolean;
}

const columnsFormatter = (
  onDelete: (id: number) => void,
  deleting: boolean
) => [
  {
    Header: "Id",
    accessor: "id",
    headerClassName: "text-left",
    width: 64,
    Cell: ({ value }) => <span>{value}</span>
  },
  {
    Header: "Club",
    accessor: "club",
    headerClassName: "text-left",
    width: 128,
    Cell: ({ value }) => <span>{value}</span>
  },
  {
    Header: "Factura",
    accessor: "folioFactura",
    headerClassName: "text-left",
    width: 96,
    Cell: ({ value }) => <span>{value}</span>
  },
  {
    Header: "Tipo",
    accessor: "tipo",
    headerClassName: "text-left",
    width: 128,
    Cell: ({ value }) => <span>{formatEnum(value)}</span>
  },
  {
    Header: "Empleado",
    accessor: "empleado",
    headerClassName: "text-left",
    width: 160,
    Cell: ({ value }) => <span>{value}</span>
  },
  {
    Header: "Descripción",
    accessor: "descripcion",
    headerClassName: "text-left",
    Cell: ({ value }) => <span>{value}</span>
  },
  {
    Header: "Monto",
    accessor: "montoComision",
    headerClassName: "text-right",
    width: 80,
    Cell: ({ value }) => (
      <div style={{ textAlign: "right" }}>{formatMoney(value || 0, 2)}</div>
    )
  },
  {
    Header: "F. de Pago",
    accessor: "fechaPago",
    headerClassName: "text-left",
    width: 96,
    Cell: ({ value }) => <span>{formatIsoDate(value)}</span>
  },
  {
    Header: "",
    accessor: "id",
    width: 48,
    Cell: ({ value, original }) => (
      <div style={{ textAlign: "center" }}>
        <>
          <span
            id={`del-${value}-trash`}
            onClick={() => onDelete(value)}
            style={{
              cursor: !!original.idArchivoMaquila ? "default" : "pointer"
            }}
          >
            <FontAwesomeIcon
              icon={faTrash}
              color={!!original.idArchivoMaquila ? "#ccc" : "#900"}
            />
          </span>
          <UncontrolledTooltip placement="top" target={`del-${value}-trash`}>
            {!!original.idArchivoMaquila
              ? "La comisión ya se procesó"
              : "Eliminar comisión"}
          </UncontrolledTooltip>
        </>
      </div>
    )
  }
];

export const MemoTable = React.memo(
  ({ comisiones, loading, onDelete, deleting }: TableProps) => {
    const [columns, setColumns] = useState(
      columnsFormatter(onDelete, deleting)
    );

    useEffect(() => {
      setColumns(columnsFormatter(onDelete, deleting));
    }, [onDelete, deleting]);

    return (
      <div>
        <div className="row">
          {!!comisiones && !!comisiones.length && (
            <div className="col-12 p-0" style={{ lineHeight: "40px" }}>
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;Comisiones manuales mostradas:{" "}
                {comisiones.length}
              </span>
            </div>
          )}
        </div>
        <ReactTable
          manual
          data={comisiones || []}
          columns={columns}
          loading={loading}
          showPagination={false}
          defaultPageSize={comisiones ? comisiones.length : 0}
          minRows={5}
          noDataText="No se encontraron comisiones manuales"
          className="-striped -highlight"
        />
      </div>
    );
  }
);
